export class Roster {
  constructor() {
    document.querySelectorAll('[data-roster]').forEach((root) => this.#bind(root))
  }

  #bind(root) {
    const filters = [...root.querySelectorAll('[data-roster-filter]')]
    const cards = [...root.querySelectorAll('[data-roster-card]')]
    const swiper = () => root.querySelector('.swiper')?.swiper

    const sync = (position = null) => {
      cards.forEach((card) => {
        const hide = position
          ? card.getAttribute('data-position') !== position
          : card.hidden
        card.hidden = hide
        const slide = card.closest('.swiper-slide')
        if (slide) slide.style.display = hide ? 'none' : ''
      })
      swiper()?.update()
    }

    sync()

    if (filters.length && cards.length) {
      filters.forEach((btn) => {
        btn.addEventListener('click', () => {
          const position = btn.getAttribute('data-roster-filter')
          filters.forEach((el) => {
            const active = el === btn
            el.classList.toggle('is-active', active)
            el.setAttribute('aria-pressed', active ? 'true' : 'false')
          })
          sync(position)
          swiper()?.slideTo(0)
        })
      })
    }

    const details = [...root.querySelectorAll('.c-player__details')]
    details.forEach((el) => {
      el.addEventListener('toggle', () => {
        if (el.open) {
          details.forEach((other) => {
            if (other !== el) other.open = false
          })
        }
        swiper()?.update()
      })
    })

    root.querySelectorAll('.c-player--club').forEach((card) => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('a, summary')) return
        const el = card.querySelector('.c-player__details')
        if (el) el.open = !el.open
      })
    })
  }
}
